import { countDate } from './date';

export const formatDate = date => countDate(date, false).trim();

const dateKeys = ['createdDate', 'date', 'created', 'updated'];

export const filterData = (data, filters, transformStatus) => {
    return data.filter(row => {
        return Object.entries(filters).every(([key, value]) => {
            if (!value) return true;

            if (key === 'status') {
                return transformStatus ? transformStatus(row[key]) === value : row[key] === value;
            }

            if (key === 'group') {
                if (typeof row[key] === 'object') {
                    return Object.values(row[key]).some(
                        groupValue =>
                            groupValue !== null &&
                            groupValue !== undefined &&
                            String(groupValue).toLowerCase() === String(value).toLowerCase()
                    );
                }
                return String(row[key]).toLowerCase() === String(value).toLowerCase();
            }

            if (dateKeys.includes(key)) {
                if (value && typeof value === 'object') {
                    if (!value.from && !value.to) return true;
                    const rowDate = new Date(row[key]);
                    if (isNaN(rowDate)) return true;
                    if (value.from && value.to) {
                        return rowDate >= new Date(value.from) && rowDate <= new Date(value.to + 'T23:59:59');
                    }
                    if (value.from) {
                        const today = new Date();
                        today.setHours(23, 59, 59, 999);
                        return rowDate >= new Date(value.from) && rowDate <= today;
                    }
                    if (value.to) {
                        return rowDate <= new Date(value.to + 'T23:59:59');
                    }
                    return true;
                }
                return formatDate(row[key]).includes(value);
            }

            const rowValue = row[key] !== undefined && row[key] !== null ? String(row[key]) : '';
            const filterValue = String(value);

            return rowValue.toLowerCase().includes(filterValue.toLowerCase());
        });
    });
};
